<template>
    <!-- Location Picker Component -->
    <div>
        <modal class="map-modal" :name="modal_name" transition="nice-modal-fade" :delay="100">
			<div class="v-modal-content">
				<div class="v-modal-header">
                    <div>
					    <span class="v-modal-dialog-title v-modal-title headerPosition">SELECT IN MAP</span>
                    </div>
                    <div>
					    <span class="icon icon-close mr-2 text-lightBlue pointer" @click="hidemap()"></span>
                    </div>
				</div>
				<div class="v-modal-body">
					<div class="v-modal-layout">
						<div class="col-lg-12">
							<location-picker v-model="company_location" :options="options"></location-picker>
						</div>
					</div>
				</div>
				<div class="v-modal-dialog-actions">
					<button type="button" class="btn btn-white btn-smm btn-no-border-blue ml-3" @click="hidemap()" style="color: #00448b;background-color: transparent; box-shadow: none;">CANCEL</button>
					<button type="button" class="btn btn-secondary btn-smm" style="box-shadow: none;" @click="hidemap()">ADD</button>
				</div>
			</div>
		</modal>
    </div>
</template>
<script>
import { LocationPicker } from "vue2-location-picker";
import { EventBus } from "./eventBus/nav-bar-event.js";
import  {see_location}  from "./mixins/location.js";
export default {
    data() {
        return {
            // selectMap: false,
            options: {
                // is not
                map: {
                    /** other map options **/
                },
                marker: {
                    /** marker options **/
                },
                autocomplete: {
                    /** autocomplete options **/
                }
            },
            company_location: {
                lat: 41.0082376,
                lng: 28.97835889999999
            },
            billing_location: {
                lat: 41.0082376,
                lng: 28.97835889999999
            },
            location: {
                lat: 41.0082376,
                lng: 28.97835889999999
            },
            // finds:[{company_location:{lat: 41.0082376,lng: 28.97835889999999}},{company_location:{lat: 41.0082376,lng: 28.97835889999999}}]
        }
    },
    props: ['modal_name'],
    mounted() {
        // EventBus.$on('ShowMap', (map) => {
        //     this.selectMap = !this.selectMap;
        //     console.log("Map Received");
        // });
        // EventBus.$on('EditShowMap', (map) => {
        //     this.selectMap = !this.selectMap;
        //     console.log("Edit Map Received");
        // });
        // EventBus.$on('Map About', (map) => {
        //     this.$modal.show("map-modal");
        //     console.log("Map Received");
        // });
        // EventBus.$on('Contact Map', (map) => {
        //     this.selectMap = !this.selectMap;
        //     console.log("Contact Map Received");
        // });
        // EventBus.$on('Edit Contact Map', (map) => {
        //     this.selectMap = !this.selectMap;
        //     console.log("Edit Contact Map Received");
        // });
        // EventBus.$on('ShowMapBilling', (map) => {
        //     this.selectMap = !this.selectMap;
        //     console.log("Billing Map Received");
        // });
    },
    methods: {
        // showMap() {
        //     // this.selectMap = !this.selectMap;
        //     EventBus.$emit('ShowMap', this.selectMap);
        // },
        // showEditMap() {
        //     EventBus.$emit('Edit Contact Map', this.selectMap);
        // },
        // showContactMap() {
        //     // this.selectMap = !this.selectMap;
        //     EventBus.$emit('Contact Map', this.selectMap);
        // },
        // editShowMap() {
        //     EventBus.$emit('EditShowMap', this.selectMap);
        // },
        // hideAboutMap() {
        //     EventBus.$emit('Hide Map', false);
        // },
        // showMapBilling() {
        //     // this.selectMap = !this.selectMap;
        //     EventBus.$emit('showMapBilling', this.selectMap);
        // },
        hidemap() {
            this.$modal.hide(this.modal_name);
        }
    },
    components: {
        LocationPicker
    },
    watch:{
		company_location:function(newVal){
            this.$log.debug(see_location)
			see_location(this.company_location,this);
		},
		billing_location:function(newVal){
		    see_location(this.billing_location,this);
        },


	}
};
</script>



// WEBPACK FOOTER //
// src/components/SelectMap.vue